<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Importar modelo"
             col-md="col-md-5" offset="3">
    <template v-slot:modalContent>
      <div class="row overflow-auto" style="max-height: 800px" id="container_imagens">
        <!-- Se não houver modelos -->
        <div v-if="!dados.length" class="col-12 text-center text-muted py-3">
          Não há modelos para exibir.
        </div>

        <!-- Se houver imagens -->
        <div
            v-else
            v-for="dado in dados"
            :key="dado.id"
            :id="'card_' + dado.key"
            class="col-md-4 mb-4 d-flex justify-content-center imagem-card"
            @click="selectModelo(dado.key, dado)"
        >
          <Card :id="'card_' + dado.key" style="width: 15rem; overflow: hidden" :class="{ 'selecionado': selecionado === dado.key }">
            <template #header>
              <Image :src="dado.imagem_default ? 'data:image/png;base64,' + dado.imagem_default : '/img/naodisponivel.jpg'" alt="modelo_imagem" width="259" preview/>
            </template>
            <template #content>
              <p class="text-center"><strong>{{ dado.descricao }}</strong></p>
              <p class="text-center"><strong>{{ dado.descritivo }}</strong></p>
            </template>
          </Card>
        </div>
      </div>
      <br>
      <div class="ibox-footer">
        <div class="float-right">
          <button type="submit" @click="confirmarModelo()" class="btn btn-primary font-bold">Confirmar</button>
        </div>
        <button class="btn btn-danger font-bold" @click="$emit('fecharSubModal')">Cancelar</button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "ImportarModelo",
  components: {
    BaseModal,
  },
  data() {
    return {
      dados: [],
      selecionado: null,
    }
  },
  emits: ["modeloSelecionado", "fecharSubModal"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.modelos.createList);
      if (resultado.success) {
        this.dados = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    selectModelo(key, modelo) {
      this.selecionado = key
      this.$emit("modeloSelecionado", modelo)
    },
    confirmarModelo() {
      this.$emit('fecharSubModal');
    }
  },
  mounted() {
    this.getDados();
  },
}
</script>

<style scoped>
.imagem-card .p-card {
  border: 3px solid transparent;
  cursor: pointer;
}

.selecionado {
  border: 3px solid #28a745 !important;
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.6);
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
}
</style>


